// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UAvZy{margin-top:18px;margin-bottom:8px}.UAvZy.u8yjj{margin-bottom:0}.Z7V9g{margin-bottom:8px}.RExmG{margin-left:6px}.wRol5{white-space:pre-wrap}.iQkOn{padding:4px;margin:16px 0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spacing0": `0px`,
	"spacing2": `2px`,
	"spacing4": `4px`,
	"spacing8": `8px`,
	"spacing12": `12px`,
	"spacing16": `16px`,
	"spacing20": `20px`,
	"spacing24": `24px`,
	"spacing32": `32px`,
	"spacing40": `40px`,
	"tableTitle": `UAvZy`,
	"tableTitleTight": `u8yjj`,
	"tableSubtitle": `Z7V9g`,
	"learnMoreLink": `RExmG`,
	"preserveLineBreak": `wRol5`,
	"mailCallout": `iQkOn`
};
export default ___CSS_LOADER_EXPORT___;
